export default __webpack_public_path__ + "static/media/Floor_Plan_3D_Standard.296b5bdc.jpg";